const nameUsedLogged = "userlogged";

export function isLogged() {
    return getUserLogged() != null;
}

export function getUserLogged() {
    return JSON.parse(localStorage.getItem(nameUsedLogged));
}

export function setUserLogged(user) {
    localStorage.setItem(nameUsedLogged, JSON.stringify(user));
}

export function removeUserLogged() {
    localStorage.removeItem(nameUsedLogged);
}

export function logout() {
    removeUserLogged();
}